import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PcOptimizationviewComponent } from './pc-optimizationview.component';

// ✅ Forms
import { FormsModule } from '@angular/forms';

// ✅ Angular Material
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { PcMultiSelectFilterModule } from 'src/app/shared/components/pc-multi-select-filter/pc-multi-select-filter.module';
import { ConfirmPopupModule } from 'src/app/modules/confirm-popup/confirm-popup.module';

@NgModule({
  declarations: [
    PcOptimizationviewComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,

    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatAutocompleteModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatTooltipModule,
    MatDialogModule,
    ConfirmPopupModule,
    PcMultiSelectFilterModule
  ],
  exports: [
    PcOptimizationviewComponent
  ]
})
export class PcOptimizationviewModule { }